// frontend/src/components/orcamento/PainelPilares.js
// Rodapé fixo: por pilar (departamento), receita, despesa e resultado orçados,
// margem (resultado ÷ receita) e a diferença do resultado contra o realizado do
// ano anterior. Se a base termina no próprio ano anterior (ano incompleto), o
// realizado é anualizado (× 12 / meses com dado) e o tooltip diz isso.
import React from 'react';

const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(Math.abs(v || 0));
// sinal explícito no resultado (− prejuízo), não só a cor
const fmtSinal = (v) => `${v < 0 ? '−' : ''}${fmt(v)}`;

function Linhas({ rec, desp }) {
  const res = rec - desp;
  return (
    <>
      <div className="l"><span>Rec</span><b>{fmt(rec)}</b></div>
      <div className="l"><span>Desp</span><b>{fmt(desp)}</b></div>
      <div className={`l res ${res < 0 ? 'neg' : ''}`}>
        <span>Res</span><b>{fmtSinal(res)}</b>
        {rec > 0 && <em>{((res / rec) * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%</em>}
      </div>
    </>
  );
}

export default function PainelPilares({ pilares, nomesPilar, realizadoPorPilar, totais, ano, baseFim, grupo = false }) {
  const chaves = Object.keys(pilares).sort((a, b) =>
    ((pilares[b].receita + pilares[b].despesa) - (pilares[a].receita + pilares[a].despesa)));
  const anoAnt = ano - 1;
  const [fimAno, fimMes] = String(baseFim || '').split('-').map(Number);
  const parcial = fimAno === anoAnt && fimMes >= 1 && fimMes < 12;
  const mesesComDado = parcial ? fimMes : 12;
  const explica = parcial
    ? `Resultado realizado de ${anoAnt} até ${String(fimMes).padStart(2, '0')}/${anoAnt}, anualizado (× 12 / ${fimMes})`
    : `Resultado realizado de ${anoAnt}`;
  return (
    <div className="op-rodape">
      <div className="op-pilar total">
        <div className="n">Resultado do ano{grupo ? ' do grupo' : ''}</div>
        <Linhas rec={totais.receita.ano} desp={totais.despesa.ano} />
      </div>
      {chaves.map((dep) => {
        const { receita, despesa } = pilares[dep];
        const res = receita - despesa;
        const real = realizadoPorPilar ? realizadoPorPilar[dep] : undefined;
        // comparação só do resultado, em R$ (percentual sobre resultado perto de zero não diz nada)
        const realAnual = real ? (real.receita - real.despesa) * 12 / mesesComDado : null;
        const dif = (realAnual !== null && (real.receita || real.despesa)) ? res - realAnual : null;
        return (
          <div className="op-pilar" key={dep || '__sem__'}>
            <div className="n">{dep ? (nomesPilar[dep] || dep) : 'Sem departamento'}</div>
            <Linhas rec={receita} desp={despesa} />
            {dif !== null && (
              <div className={`d ${dif >= 0 ? 'melhor' : 'pior'}`} title={`${explica}: ${fmtSinal(realAnual)}`}>
                {dif >= 0 ? '▲ +' : '▼ −'}{fmt(dif)} vs. {anoAnt}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
